<template>
  <secretary-profile :memberDetails="memberDetails" :edit="true" />
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import axios from 'axios'
import secretaryProfile from '@/views/Admin/Add/SecretaryAdd'

export default {
  name: 'SecretaryProfile',
  components: {
    'secretary-profile': secretaryProfile
  },
  data() {
    return {
      memberDetails: {}
    }
  },
  mounted() {
    if (this.$route.params && this.$route.params.slug) {
      this.getData(this.$route.params.slug)
    }
  },
  methods: {
    getData(slug) {
      axios.get(`${this.$api}/admin/secretary/${slug}`).then((response) => {
        if (response.status === 200) {
          this.memberDetails = response.data.data
        }
      }).catch((error) => {
        // eslint-disable-next-line
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Admin/Profile/SecretaryProfile.vue